import { HttpClient } from '../httpClient';
import Discipline from '../models/discipline';
import DisciplinesResponse from '../responses/disciplinesResponse';
import DisciplineResponse from '../responses/disciplineResponse';
import { BaseResponse, DataResponse } from '../responses/baseResponse';
import DisciplineTherapists from '../models/disciplineTherapists';
import { getAllTherapists } from './therapistService';
import DisciplineGroupRulesResponse from '../responses/disciplineGroupRulesResponse';
import DisciplineGroupsWithRulesResponse from '../responses/disciplineGroupsWithRulesResponse';
import DisciplineGroupRule from '../models/disciplineGroupRule';

const httpClient = new HttpClient();

export const getDisciplines = async () => {
  return httpClient.get<DisciplinesResponse>({
    url: '/v1/Disciplines',
    requiresToken: true,
  });
};

export const getDiscipline = async (disciplineId: number) => {
  return httpClient.get<DisciplineResponse>({
    url: `/v1/Disciplines/${disciplineId}`,
    requiresToken: true,
  });
};

export const createDiscipline = async (discipline: Discipline) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/admin/disciplines',
    payload: discipline,
    requiresToken: true,
  });
};

export const updateDiscipline = async (discipline: Discipline) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/disciplines/${discipline.disciplineId}`,
    payload: discipline,
    requiresToken: true,
  });
};

export const deleteDiscipline = async (disciplineId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/disciplines/${disciplineId}`,
    requiresToken: true,
  });
};

export const getAllDisciplines = async () => {
  return await httpClient.get<DisciplinesResponse>({
    url: '/v1/Disciplines',
    requiresToken: true,
  });
}

export const getDisciplineTherapists = async () => {
  const disciplines = await getAllDisciplines();
  const therapists = await getAllTherapists();

  return { disciplines: disciplines.data.disciplines, therapists: therapists.data } as DisciplineTherapists;
};

export const getDisciplinesGroupsWithRules = async () => {
  return httpClient.get<DisciplineGroupsWithRulesResponse>({
    url: '/v1/admin/disciplines/disciplineGroupsWithRules',
    requiresToken: true
  })
}

export const getDisciplineGroupRules = async (disciplineGroupId: number) => {
  return httpClient.get<DisciplineGroupRulesResponse>({
    url: `/v1/admin/disciplines/disciplineGroupRules/${disciplineGroupId}`,
    requiresToken: true
  })
}

export const saveDisciplineGroupRules = async (data: DisciplineGroupRule[]) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/disciplines/saveDisciplineGroupRules`,
    payload: data,
    requiresToken: true,
  });
}

export const getTargetDisciplines = async (startDate: Date,endDate: Date,userId: number,disciplineId: number) => {
  return httpClient.get<DataResponse<Discipline[]>>({
    url: `/v1/Disciplines/TargetDisciplineList?startDate=${startDate.toDateString()}&endDate=${endDate.toDateString()}&userId=${userId}&currentDisciplineId=${disciplineId}`,
    requiresToken: true,
  });
};